import axios from 'axios'
import Mgr from './SecureService'

const baseUrl = process.env.VUE_APP_API_LINK;
//const baseUrl = 'http://localhost:54006/api';
var user = new Mgr();
axios.defaults.baseURL = baseUrl;
export default class ApiService{

  /*
  * apiFolder - название метода
  * */

  //добавляем токен к запросу
  async defineHeaderAxios () {
    await user.getAcessToken().then(
      acessToken => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + acessToken
      }, err => {
        console.log(err)
      })
  }

  //Get запрос без параметров
  async Get (apiFolder)
  {
    var data=null;
    await axios.get(apiFolder)
      .then(response=>data=response.data)
      .catch(error => {
        data =Promise.reject(error);
      });
    return data;
  }

  //Get запрос с параметрами (ex. '?id=5&&sort=desc')
  async GetBy (apiFolder, params)
  {

    var data=null;
    await axios.get(apiFolder+params)
      .then(response=> data=response.data)
      .catch(error => {
        data= Promise.reject(error);
      })
    return data;
  }

  async Post (apiFolder, postData)
  {
    var data=null;
    await axios.post(apiFolder,postData)
      .then(response =>data= response.data)
      .catch(error => {
        data= Promise.reject(error);
      })
    return data;
  }

  async Put (apiFolder, putData)
  {
    var data= null;
    await axios.put(apiFolder,putData)
      .then(response =>data=response.data)
      .catch(error => {
        data= Promise.reject(error);
      })
    return data;
  }

  async Delete(apiFolder, deleteData)
  {
    var data= null;
    await axios.delete(apiFolder+deleteData)
      .then(response => data= response.data)
      .catch(error => {
        data= Promise.reject(error);
      });
    return data;
  }



}
